import axios from 'axios'
import { message } from 'ant-design-vue'
import { VueAxios } from './axios'


const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

// 创建 axios 实例
const request = axios.create({
  baseURL: '/thesisCheck/api/',
  timeout: 6000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  const { response } = error;
  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    const { status, url } = response;
    message.error(response.data.msg || `请求错误 ${status}: ${url}` || errorText || '您的网络发生异常，无法连接服务器');
    // notification.error({
    //   message: response.data.msg || `请求错误 ${status}: ${url}` || '您的网络发生异常，无法连接服务器' ,
    //   description: errorText,
    // });
    return response.data
  } else if (!response) {
    message.error('您的网络发生异常，无法连接服务器');
  }

  return response;
}

// response interceptor
request.interceptors.response.use(async (response) => {
  const { data } = response;
  if(!data.msgCode){
    return  data;
  }else if(response.status == 400){
    message.error(data.msg || '您的网络发生异常，无法连接服务器');
    return  response;
  }else{
    message.error(data.message || '您的网络发生异常，无法连接服务器');
    return  response;
  }
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
